import { useTranslation } from "react-i18next";
import Modal from "../../../components/modal";

export function ChatInfoModal() {
  const { t } = useTranslation(["chatPage"]);

  const content = (
    <div>
      <p>{t("chatInfoModalContent")}</p>
      <h2 className="mt-3 font-bold text-lg">{t("chat")}</h2>
      <p>{t("chatInfoModalContentChat")}</p>
      <h2 className="mt-2 font-bold text-lg">
        {t("chatInfoConversationNotice")}
      </h2>
      <p>{t("chatInfoConversationNoticeText")}</p>
      <p className="mt-2 font-bold">{t("chatInfoModalContentFeedback")}</p>
    </div>
  );

  return (
    <Modal
      id="chatInfoModal"
      title={t("chatInfoModalTitle")}
      content={content}
    />
  );
}
